import * as angular from "angular";
import {HolderType} from "../../commons/types/holder.type";
import {DocumentSettings} from "../models/document-settings.model";

export class DocumentsDialogsService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  createDocument(event, holderType: HolderType) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-document-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Create New Document';
        $scope.action = 'Create';
        $scope.cancel = self.$mdDialog.cancel;
        $scope.document = {holderType: holderType}

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide({document: $scope.document});
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editDocument(event, documentToEdit: DocumentSettings) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-document-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Edit Document';
        $scope.action = 'Edit';
        $scope.cancel = self.$mdDialog.cancel;
        $scope.document = documentToEdit

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide({document: $scope.document});
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('documentsDialogsService', DocumentsDialogsService);
